// extracted by mini-css-extract-plugin
module.exports = {"orderedList":"OrderableList_orderedList__nFtb_","list":"OrderableList_list__D9zH7","item":"OrderableList_item__ttgro","ghost":"OrderableList_ghost__cBrjH"};